import React, { memo } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Row.scss'
const rootClassName = 'component-row'

interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  centralized?: boolean
}
function Row(props: RowProps) {
  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.centralized ? 'centralized' : '',
        props.className
      ])
    }
    delete p.centralized
    return p
  }

  return <div {...getProps()}>{props.children}</div>
}

Row.defaultProps = {
  centralized: false
}

export default memo(Row)
